<div style="display: flex; width: 100%; height: calc(100% - 10px);">
    <app-guide-container [source]='source'></app-guide-container>
    <app-educational-container (buttonSelectEvent)="returnedSectionTitle($event)" [source]='source' [title]="title"></app-educational-container>
    <!-- <div class="button-container">
      <button class="button empty-button" (click)="back()">Back</button>
      <button class="button filled-green-button" (click)="nextPage()">Continue</button>
    </div> -->
  </div>
